(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cm-pc-add]');
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const textEl = button.querySelector('[data-cm-pc-add-text]');
    const originalText = textEl ? textEl.textContent.trim() : '';

    button.disabled = true;
    if (textEl) textEl.textContent = 'Adding...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        if (textEl) textEl.textContent = 'Added';

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((cart) => {
            document
              .querySelectorAll('.cm-cart-count, [data-cart-count], [data-cm-cart-count], .cart-count-bubble span')
              .forEach((badge) => {
                badge.textContent = cart.item_count;
                if (badge.hasAttribute('data-cm-count')) {
                  badge.setAttribute('data-cm-count', cart.item_count);
                }
              });
          })
          .catch(() => {});

        window.setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          button.disabled = false;
        }, 1200);
      })
      .catch(() => {
        if (textEl) textEl.textContent = 'Try Again';

        window.setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          button.disabled = false;
        }, 1500);
      });
  });
  } catch(e) { console.error(e); }
})();

})();
